import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThinClientModeService {
  static thinClientMode: boolean = false;
  static apasMode: boolean = false;
}
